// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"ccd0491f","974":"fd4ff170"}[chunkId] + ".chunk.css";
};